<template>
  <div class="pc-block inner-box">
    <bread :backTitle="$t('block.title')"></bread>
    <div class="title flex-between">
      <span class="total-block"
        >{{ $t("block.title") }}（{{ maxHeight | filterNum
        }}{{ $t("block.count") }}）</span
      >
      <page-container
        @pageChange="pageChange"
        @sizeChange="sizeChange"
        :currentPage="pages.currentPage"
        :pageSize="pages.pageSize"
        :total="pages.total"
      ></page-container>
    </div>
    <!-- 表格部分 -->
    <el-table :data="Blocks" stripe style="width: 100%" class="data-table">
      <template slot="empty">
        <div>
          <div
            v-if="Loading"
            class="loading-line"
            v-loading="Loading"
            element-loading-text="Loading..."
            element-loading-spinner="el-icon-loading"
          ></div>
          <span v-else>{{ $t("page.nodata") }}</span>
        </div>
      </template>
      <el-table-column :label="$t('block.height')" width="180">
        <template slot-scope="item">
          <router-link :to="`/block/${item.row.height}`" class="light">{{
            item.row.height
          }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="blockTime" :label="$t('block.time')" width="220">
        <template slot-scope="item">
          <count :time="item.row.blockTime"></count>
        </template>
      </el-table-column>
      <el-table-column prop="hash" :label="$t('block.hash')">
        <template slot-scope="item">
          <router-link :to="`/block/${item.row.height}`" class="light">{{
            item.row.hash | filterHash
          }}</router-link>
        </template>
      </el-table-column>
      <el-table-column :label="$t('home.mineRevenue')">
        <template slot-scope="block">{{
          block.row.height | branchIncome("BTY")
        }}</template>
      </el-table-column>
      <el-table-column prop="txCount" :label="$t('block.txCount')" width="100">
        <template slot-scope="item">
          <span class="light">{{ item.row.txCount }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 底部分页 -->
    <div class="bottom-page flex-right">
      <page-container
        @pageChange="pageChange"
        @sizeChange="sizeChange"
        :currentPage="pages.currentPage"
        :pageSize="pages.pageSize"
        :total="pages.total"
      ></page-container>
    </div>
  </div>
</template>

<script>
import Bread from "@/components/computer/Breadcrumb.vue";
import PageContainer from "@/components/computer/PageContainer.vue";
import blockBase from "@/mixins/Block/block.js";
import Count from "@/components/Count.vue";
export default {
  mixins: [blockBase],
  components: {
    Bread,
    PageContainer,
    Count,
  },
};
</script>

<style lang="scss">
.pc-block {
  .title {
    margin-top: 20px;
    .total-block {
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #53657a;
    }
  }
  .data-table {
    margin-top: 15px;
    box-shadow: 0 0.5rem 1.2rem rgba(189, 197, 209, 0.2);
    border-radius: 2px;
    border: 1px solid rgba(235, 239, 241, 1);
    color: $black;
    .el-table__header thead tr {
      height: 60px;
    }
  }
  .loading-line {
    height: 60px;
    line-height: 18px;
  }
  .bottom-page {
    margin-top: 23px;
  }
  .el-table td:nth-of-type(1) .cell,
  .el-table th:nth-of-type(1) .cell {
    padding-left: 20px;
  }
}
</style>
